import symbolName from "@/util/symbol-name.mjs";

type SymbolMap<K extends string> = Record<K, symbol>;

export default function stringsToSymbols<K extends string>(
  arr: K[],
): SymbolMap<K> {
  return arr.reduce((hash, string) => {
    hash[string] = symbolName(
      string.replaceAll(/([A-Z])/g, (_, a) => `-${a.toLowerCase()}`),
    );
    return hash;
  }, {} as SymbolMap<K>);
}
